const decorateFunction = (fn, extras) => {
    return Object.assign(fn, extras);
    // for (const k in extras) {
    //     fn[k] = extras[k];
    // }
    // return fn;
};
exports.decorateFunction = decorateFunction;
